module.exports = __webpack_public_path__ + "Fusillone-k2H.jpg";